// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   SearchBar — input with camera icon + find button
   ============================================ */

.grb-widget--search-bar {
  display: flex;
  align-items: center;
  flex: 1;
  height: 100%;
}

/* Input wrapper — contains input + photo button */
.grb-widget--search-input-wrap {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
  height: 100%;
}

/* Search icon (magnifying glass) — left side of input */
.grb-widget--search-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  flex-shrink: 0;
  pointer-events: none;
}

.grb-widget--search-icon svg {
  stroke: var(--grb-color-text-secondary);
}

.grb-widget--search-input {
  flex: 1;
  height: 100%;
  padding: 0 44px 0 0;
  border: none;
  font-size: 18px;
  background: transparent;
  letter-spacing: 0.02em;
}

.grb-widget--search-input::placeholder {
  color: var(--grb-color-text-secondary);
  font-size: inherit;
  letter-spacing: 0.02em;
}

/* Photo (camera) button inside input, right side */
.grb-widget--photo-btn {
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 0;
  transition: opacity 0.15s ease;
}

.grb-widget--photo-btn:hover {
  opacity: 0.6;
}

.grb-widget--photo-btn svg {
  width: 20px;
  height: 20px;
  stroke: var(--grb-color-text-secondary);
}

/* Search / Find button — accent filled style */
.grb-widget .grb-widget--search-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0 var(--grb-spacing-lg);
  background: var(--grb-color-primary);
  color: #fff;
  font-size: var(--grb-font-size-sm);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  white-space: nowrap;
  transition: background-color 0.15s ease;
  flex-shrink: 0;
}

.grb-widget .grb-widget--search-btn:hover {
  background: var(--grb-color-primary-hover);
}

/* Close button in toolbar */
.grb-widget--close-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 100%;
  border-left: 1px solid var(--grb-color-border);
  transition: background-color 0.15s ease;
  flex-shrink: 0;
}

.grb-widget--close-btn:hover {
  background-color: var(--grb-color-background-secondary);
}

.grb-widget--close-btn svg {
  width: 18px;
  height: 18px;
  stroke: var(--grb-color-text);
}

/* Loading spinner — same position as photo btn */
.grb-widget--search-spinner {
  display: none;
  position: absolute;
  right: 12px;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 18px;
  height: 18px;
  border: 2px solid var(--grb-color-border);
  border-top-color: var(--grb-color-primary);
  border-radius: 50%;
  animation: grb-spin 0.6s linear infinite;
}

.grb-widget--search-spinner.grb-widget--active {
  display: block;
}

@keyframes grb-spin {
  to { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/styles/search-bar.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,YAAY;AACd;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,YAAY;AACd;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;AACzC;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gCAAgC;EAChC,oCAAoC;EACpC,WAAW;EACX,kCAAkC;EAClC,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,8CAA8C;EAC9C,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,SAAS;EACT,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,0CAA0C;EAC1C,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":["/* ============================================\n   SearchBar — input with camera icon + find button\n   ============================================ */\n\n.grb-widget--search-bar {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  height: 100%;\n}\n\n/* Input wrapper — contains input + photo button */\n.grb-widget--search-input-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex: 1;\n  height: 100%;\n}\n\n/* Search icon (magnifying glass) — left side of input */\n.grb-widget--search-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  flex-shrink: 0;\n  pointer-events: none;\n}\n\n.grb-widget--search-icon svg {\n  stroke: var(--grb-color-text-secondary);\n}\n\n.grb-widget--search-input {\n  flex: 1;\n  height: 100%;\n  padding: 0 44px 0 0;\n  border: none;\n  font-size: 18px;\n  background: transparent;\n  letter-spacing: 0.02em;\n}\n\n.grb-widget--search-input::placeholder {\n  color: var(--grb-color-text-secondary);\n  font-size: inherit;\n  letter-spacing: 0.02em;\n}\n\n/* Photo (camera) button inside input, right side */\n.grb-widget--photo-btn {\n  position: absolute;\n  right: 4px;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 0;\n  transition: opacity 0.15s ease;\n}\n\n.grb-widget--photo-btn:hover {\n  opacity: 0.6;\n}\n\n.grb-widget--photo-btn svg {\n  width: 20px;\n  height: 20px;\n  stroke: var(--grb-color-text-secondary);\n}\n\n/* Search / Find button — accent filled style */\n.grb-widget .grb-widget--search-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  padding: 0 var(--grb-spacing-lg);\n  background: var(--grb-color-primary);\n  color: #fff;\n  font-size: var(--grb-font-size-sm);\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  white-space: nowrap;\n  transition: background-color 0.15s ease;\n  flex-shrink: 0;\n}\n\n.grb-widget .grb-widget--search-btn:hover {\n  background: var(--grb-color-primary-hover);\n}\n\n/* Close button in toolbar */\n.grb-widget--close-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 56px;\n  height: 100%;\n  border-left: 1px solid var(--grb-color-border);\n  transition: background-color 0.15s ease;\n  flex-shrink: 0;\n}\n\n.grb-widget--close-btn:hover {\n  background-color: var(--grb-color-background-secondary);\n}\n\n.grb-widget--close-btn svg {\n  width: 18px;\n  height: 18px;\n  stroke: var(--grb-color-text);\n}\n\n/* Loading spinner — same position as photo btn */\n.grb-widget--search-spinner {\n  display: none;\n  position: absolute;\n  right: 12px;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  width: 18px;\n  height: 18px;\n  border: 2px solid var(--grb-color-border);\n  border-top-color: var(--grb-color-primary);\n  border-radius: 50%;\n  animation: grb-spin 0.6s linear infinite;\n}\n\n.grb-widget--search-spinner.grb-widget--active {\n  display: block;\n}\n\n@keyframes grb-spin {\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
